import { IRequest } from '@r1-frontend/shared/types/IRequest';

/*
* Информация о канале по alias
* https://master.api-epg.sandbox.d2c.r-one.io/docs/#/v1/ChannelController_getChannelByAliasAndProvider
*/

export const getChannelInfoByAlias = (alias: string, providerId: number): IRequest => ({
    uri: `/api/v1/${providerId}/channels/alias/${alias}`,
    method: 'GET',
    queryParams: {
        with: 'channelInfo',
    },
    headers: {
        providerId: `${providerId}`,
    },
});
